import { render, staticRenderFns } from "./u-txt-medium.vue?vue&type=template&id=25f856ff&scoped=true&"
import script from "./u-txt-medium.vue?vue&type=script&lang=js&"
export * from "./u-txt-medium.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f856ff",
  null
  
)

export default component.exports